import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { I18nProvider } from './i18n';
import { initSession } from './lib/auth';
import './styles/index.css';

async function bootstrap(): Promise<void> {
  // Carrega a sessão persistida (Dexie) antes de montar — evita flash de tela de login.
  await initSession();

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Elemento #root não encontrado em index.html');
  }

  createRoot(rootElement).render(
    <StrictMode>
      <I18nProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </I18nProvider>
    </StrictMode>,
  );
}

void bootstrap();
